import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';
import _ from 'underscore';

import {ConnectionSchema} from 'instruments/connection-schemas/ConnectionSchemaConstants';
import {InstrumentAdapter} from 'instruments/connections/ConnectionConstants';
import {listInstrumentTypes} from 'instruments/connections/ConnectionDAO';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import useOnMount from 'ui-library/hooks/useOnMount';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

interface InstrumentTypeSelectorProps {
  value: string | null;
  onChange: (adapterId: string) => void;
  schema?: ConnectionSchema | null;
}

export default function InstrumentTypeSelector(props: InstrumentTypeSelectorProps): JSX.Element {
  const [instrumentTypes, setInstrumentTypes] = useState([] as Array<InstrumentAdapter>);
  useOnMount((): void => {
    listInstrumentTypes().then(({instrumentAdapters}) => {
      setInstrumentTypes(instrumentAdapters);
    });
  });
  const selectedInstrumentType = instrumentTypes.find((instrumentType) => instrumentType.id === props.value);
  return (
    <InputWrapper
      id={_.uniqueId('adapterId')}
      label="Integration Adapter"
      labelStyle={FieldLabel.STYLES.LABEL}
      isRequired={true}
    >
      {props.schema == null ? (
        <SelectDropdown
          className={css(styles.dropdown)}
          displayName={selectedInstrumentType ? selectedInstrumentType.displayName : 'None'}
          menu={
            <Menu value={props.value} height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL} scrollable={true}>
              {instrumentTypes.map((instrumentType) => (
                <Option
                  key={instrumentType.id}
                  value={instrumentType.id}
                  onSelect={() => {
                    props.onChange(instrumentType.id);
                  }}
                >
                  {instrumentType.displayName}
                </Option>
              ))}
            </Menu>
          }
        />
      ) : (
        <span className="settingsPageContainer-readOnlyValue">{selectedInstrumentType?.displayName}</span>
      )}
    </InputWrapper>
  );
}

const styles = StyleSheet.create({
  dropdown: {
    flex: 1,
  },
});
